import { getContext, setContext } from 'svelte';
import { writable, type Writable } from 'svelte/store';
import { StoreKeys } from './StoresKeys';

export type EffectiveRoofValues = {
	selectedRoof: number | 'all';
	effectivePvSize: number;
	effectiveAmountOfModule: number;
};

const getDefaults = (): EffectiveRoofValues => ({
	selectedRoof: 'all',
	effectivePvSize: 0,
	effectiveAmountOfModule: 0
});

const effectiveStore = writable<EffectiveRoofValues>(getDefaults());

export const useEffectiveRoofStore = (initialValues?: EffectiveRoofValues) => {
	if (initialValues) {
		effectiveStore.set(initialValues);
	}

	const setEffectiveRoofStore = () => {
		setContext(StoreKeys.CONFIGURATOR_EFFECTIVE_ROOF, effectiveStore);
	};

	return {
		setEffectiveRoofStore,
		...effectiveStore
	};
};

export const getEffectiveRoofStore = (): Writable<EffectiveRoofValues> => {
	return getContext(StoreKeys.CONFIGURATOR_EFFECTIVE_ROOF);
};
